import { atom } from 'recoil';
import { DEFAULT_PAGE } from '../types/types';

export const wizardStepAtom = atom<number>({
    key: 'wizardStep',
    default: DEFAULT_PAGE
});
